<script>
import { mapState } from "vuex";

// Menu do usuário (avatar, nome e botão de sair) para páginas sem a nav-bar
export default {
  locales: {
    pt: {
      'Logout': 'Sair',
    },
    es: {
      'Logout': 'Cerrar Sesión',
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
};
</script>

<template>
  <b-dropdown right variant="link" class="user-menu" toggle-class="user-menu-toggle p-1">
    <template v-slot:button-content>
      <img v-if="account.user.avatar" class="rounded-circle user-menu-avatar" :src="account.user.avatar" alt="" />
      <img v-else class="rounded-circle user-menu-avatar" :src="'https://ui-avatars.com/api/?background=2C00F5&color=fff&name=' + account.user.name" alt="" />
      <span class="d-none d-md-inline-block ml-2">{{ account.user.username }}</span>
      <i class="mdi mdi-chevron-down d-none d-md-inline-block"></i>
    </template>
    <router-link tag="a" to="/logout" class="dropdown-item">
      <span>{{ t('Logout') }}</span>
    </router-link>
  </b-dropdown>
</template>
